<template>
  <div class="menuFrame">
    <article class="indexMargin">
      <div class="contentBox">
        <div class="PcDevice">
          <h1 class="display-4" style="font-weight: 400">Welcome to Exhibitor's Online Service System</h1>

          <div class="d-flex justify-content-between align-items-center">
            <div class="lead my-4" style="font-size: 19px">
              Please select an exhibition and complete the required steps:
            </div>
            <div>
              <span class="bold">Account :</span>
              <span> {{ UserId }}</span>
            </div>
          </div>
        </div>
        <div class="MbDevice">
          <p class="mb-2 ml-1" style="font-size: 13px; margin-top: 10px">
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </p>
          <hr />
          <div class="font-weight-normal h2 my-3">Welcome to Exhibitor's Online Service System</div>

          <div class="lead mb-4" style="font-size: 17px">
            Please select an exhibition and complete the required steps:
          </div>
        </div>
        <hr />

        <p class="my-3">&nbsp;</p>

        <div v-if="hasExh">
          <ul v-for="item in ExhibitionList" class="mx-5 my-3">
            <li>
              <div class="row justify-content-between align-items-center">
                <div class="col-sm-8 text-sm-left text-center">
                  <div class="lineStyle align-items-center">
                    <div class="mr-sm-5">
                      <img
                        :src="`//www.ccie.com.tw/exhibition/images/exlogo/${item.ExhLogo}`"
                        class="img-fluid imgSize"
                      />
                    </div>
                    <div>
                      <p class="bold mb-1" style="font-size: 18px">{{ item.Exhibition }}</p>
                      <span>
                        <p class="gray">{{ item.ExhBegin }} ~ {{ item.ExhEnd }}</p>
                        <p class="gray">{{ item.ExhVenue }}</p>
                        <p class="divider">&nbsp;</p>
                        <p>
                          <span class="colorBG">{{ item.AppNo }}</span> {{ item.Directory_eComName }}
                        </p>
                        <p>Exhibition Area : {{ item.ExhibArea }}</p>
                        <p>
                          Booth No. :
                          <span v-if="item.BoothNo == 'N/A'"> - </span>
                          <span v-else> {{ item.BoothNo }} </span>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4 text-right PcDevice">
                  <div v-if="item.Del == 'c'">
                    <div class="btn btn-lg btn-primary" @click.prevent="ExhibitionHomeEN(item.RegNo)">Enter</div>
                  </div>

                  <div v-else-if="item.Del == 'd'">
                    <button type="button" class="btn btn-lg btn-secondary" disabled>Withdrawal Pending</button>
                  </div>
                </div>
                <div class="col-sm-4 mb-2 text-center MbDevice">
                  <div v-if="item.Del == 'c'">
                    <div class="btn btn-primary" @click.prevent="ExhibitionHomeEN(item.RegNo)">Enter</div>
                  </div>
                  <div v-else-if="item.Del == 'd'">
                    <button type="button" class="btn btn-secondary" disabled>Withdrawal Pending</button>
                  </div>
                </div>
              </div>
            </li>
            <hr />
          </ul>
        </div>

        <div v-else style="font-size: 21px" class="pb-5 pt-4">
          You are not an exhibitor or have not been granted access to Exhibitor's Online Service. Please feel free to
          <a href="https://www.chanchao.com.tw/en/contact.asp" target="_blank">contact us</a>.
        </div>
      </div>
    </article>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    components: {},

    metaInfo() {
      return {
        title: `Chan Chao Exhibitor's Online Service System`,
      }
    },

    data() {
      return {
        ExhibitionList: [],
        UserId: '',
        hasExh: true,
        DelExh: '',
      }
    },
    methods: {
      ExhibitionHomeEN(id) {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/home?no=${id}`
      },
    },

    created() {
      const vm = this

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition?lang=en`).then((response) => {
        if (response.data.Code == 200) {
          vm.ExhibitionList = response.data.Data
          vm.hasExh = true
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
          vm.hasExh = false
        } else {
          alert('Server is busy, please try again later.')
        }
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })
    },
  }
</script>

<style lang="scss">
  .colorBG {
    background-color: #eee;
    display: inline;
    padding: 2px 5px;
  }

  .imgSize {
    width: 180px;
  }

  .lineStyle {
    display: flex;
  }

  @media (max-width: 501px) {
    .lineStyle {
      display: block;
      margin-bottom: 25px;
    }

    .imgSize {
      width: 100px;
      margin-bottom: 15px;
    }
  }

  .display-4 {
    font-size: 2.6rem;
  }
</style>
